export enum RelatedEventsExperimentValues {
    control = 'control',
    new = 'new',
}

export const NEW_RELATED_EVENTS_UX_EXPERIMENT = {
    experimentName: 'related_events_new_ux',
    param: 'ux',
    defaultValue: RelatedEventsExperimentValues.control,
};
